<!-- eslint-disable -->
<template lang="pug">
    .multiplayer-game-menu__selectors
        cs-multiselect.selector.difficulty-selecor(
            :multiple="false",
            :show-labels="false",
            label="label",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedDifficulty",
            :options="difficulties",
            :disabled="gameState === 'started'"
        )
        cs-multiselect.selector.amount-of-examples-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedAmountOfExamples",
            :options="amountsOfExamples",
            :disabled="gameState === 'started' || commonParams && (!!commonParams.timeLimit || commonParams.infinityAmountOfExamples)"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
                |
        cs-multiselect.selector.infinite-amount-of-examples(
            :options="infiniteOptions",
            v-model='selectedInfiniteAmountOfExamplesStatus',
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples')",
            :multiple="false",
            :allow-empty="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            label="label",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples') }}:
                |
        cs-multiselect.selector.amount-of-actions-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedAmountOfActions",
            :options="amountsOfActions",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_actions') }}:
                |
        cs-multiselect.selector.amount-of-unknowns-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedAmountOfUnknowns",
            :options="amountsOfUnknowns",
            :disabled="gameState === 'started' || amountsOfUnknowns.length === 1"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_unknownsShort') }}:
                |
        cs-checkbox.selector.combining-checkbox-selector(
            :checked="isCombiningEnabled"
            @change.native="combiningHandler"
            :disabled="combiningDisabled"
        ) {{ $i18n.t('trainer.trainer_gameFormSetting_digitsCombiningShort') }}
        cs-multiselect.selector.digits-combining-selector(
            v-show="isCombiningEnabled",
            :multiple="true",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :hide-selected='true',
            :allow-empty="false",
            :min="2",
            :max="selectedDifficulty && selectedDifficulty.value"
            label="value",
            :value="selectedCombiningOptions",
            :options="combiningOptions",
            :disabled="combiningDisabled",
            @select="selectedCombiningOptions.push($event)",
            @remove="removeSelectedCombiningOptions",
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_digitsCombining')"
        )
        cs-multiselect.selector.players-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="playersAmount",
            :options="players",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_players') }}:
                |
</template>

<script>
    /*eslint-disable*/
    import MultiplayerOptionsMixin from "../../../utils/multiplayer/optionsMixin";
    import { cloneDeep } from 'lodash';

    const INFINITE_AMOUNT_OF_EXAMPLES_PARAMETER = 'infinityAmountOfExamples';
    const COMMON_PARAMETERS_CHANGED_EVENT = 'commonParametersHasChanged';

    export default {
        mounted () {
            this.selectedDifficulty = this.difficulties.find(difficulty => difficulty.name === this.commonParams.difficult);
            this.selectedAmountOfExamples = this.commonParams.amountOfExamples;
            this.selectedAmountOfActions = this.commonParams.amountOfActions;
            this.selectedAmountOfUnknowns = this.commonParams.amountOfUnknowns;
            this.amountsOfUnknowns = this.commonParams.amountOfActions > 2 ?
                [...Array(this.commonParams.amountOfActions).keys()].slice(1) :
                [1];
            if (this.commonParams.combining) {
                this.isCombiningEnabled = true;
                this.selectedCombiningOptions = this.combiningOptions.filter(option => {
                    return this.commonParams.combiningDigitCapacities.includes(option.value)
                });
            }
            this.selectedInfiniteAmountOfExamplesStatus = this.infiniteOptions.find(option => option.status === this.commonParams.infinityAmountOfExamples);
        },
        watch: {
            selectedDifficulty: {
                handler (value, oldValue) {
                    if (oldValue !== null) {
                        this.commonParams.difficult = value.name;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'difficult', value: this.commonParams.difficult});
                        if (value.value === 1) {
                            this.isCombiningEnabled = false;
                        }
                    }
                }
            },
            selectedAmountOfExamples: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.amountOfExamples = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'amountOfExamples', value: this.commonParams.amountOfExamples});
                    }
                },
            },
            selectedAmountOfActions: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.amountOfActions = value;
                        this.amountsOfUnknowns = value > 2 ? [...Array(value).keys()].slice(1) : [1];
                        if (this.selectedAmountOfUnknowns >= +value) {
                            this.selectedAmountOfUnknowns = +value - 1;
                        }
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'amountOfActions', value: this.commonParams.amountOfActions});
                    }
                }
            },
            selectedAmountOfUnknowns: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.amountsOfUnknowns = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'amountOfUnknowns', value: this.commonParams.amountsOfUnknowns});
                    }
                }
            },
            combiningOptions: {
                handler (value, oldValue) {
                    if (oldValue && oldValue.length && this.selectedCombiningOptions && this.selectedCombiningOptions.length) {
                        this.selectedCombiningOptions = value;
                    }
                },
                deep: true
            },
            selectedCombiningOptions: {
                handler (value, oldValue) {
                    this.handleMultiselectStyleState(!(value && value.length))
                    if (oldValue !== null) {
                        if (value && value.length) {
                            if (value.length < 2) {
                                this.selectedCombiningOptions.push(this.combiningOptions.find(option => !value.includes(option)));
                                return;
                            }
                            this.commonParams.combining = true;
                            this.commonParams.combiningDigitCapacities = value.map(option => option.value);
                        } else {
                            this.commonParams.combining = false;
                            this.commonParams.combiningDigitCapacities = [];
                        }
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                            setCombiningValues: true,
                            names: ['combining', 'combiningDigitCapacities'],
                            values: [this.commonParams.combining, this.commonParams.combiningDigitCapacities]
                        });
                    }
                },
                deep: true,
            },
            selectedInfiniteAmountOfExamplesStatus: {
                handler (value, oldValue) {
                    if (oldValue !== null) {
                        this.commonParams.infinityAmountOfExamples = value.status;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                            name: INFINITE_AMOUNT_OF_EXAMPLES_PARAMETER,
                            value: value.status
                        });
                    }
                }
            }
        },
        mixins: [MultiplayerOptionsMixin],
        data () {
            return {
                selectedDifficulty: null,
                selectedAmountOfExamples: 0,
                selectedAmountOfActions: 0,
                selectedAmountOfUnknowns: 0,
                selectedCombiningOptions: null,
                isCombiningEnabled: false,
                difficulties: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_singleDigits'),
                        name: 'Однозначные цифры',
                        $isDisabled: false,
                        value: 1,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_doubleDigits'),
                        name: 'Двузначные цифры',
                        $isDisabled: false,
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_tripleDigits'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false,
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_fourDigits'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false,
                        value: 4,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_fiveDigits'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false,
                        value: 5,
                    }
                ],
                amountsOfExamples: [...Array(101).keys()].slice(1),
                amountsOfActions: [...Array(11).keys()].slice(2),
                amountsOfUnknowns: [...Array(10).keys()].slice(1),
                infiniteOptions: [
                    {
                        status: true,
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated'),
                    },
                    {
                        status: false,
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated'),
                    }
                ],
                selectedInfiniteAmountOfExamplesStatus: null,
            }
        },
        methods: {
            removeSelectedCombiningOptions (removedOption) {
                if (this.selectedCombiningOptions.length > 2) {
                    this.selectedCombiningOptions = this.selectedCombiningOptions.filter(option => option.value !== removedOption.value);
                }
            },
            combiningHandler () {
                this.isCombiningEnabled = !this.isCombiningEnabled;
                if (!(this.selectedCombiningOptions && this.isCombiningEnabled)) {
                    this.selectedCombiningOptions = [];
                }
            },
            handleMultiselectStyleState (removeStyles) {
                //set last multiselect tags to be in one height with another
                let combiningMultiselectTags = document.querySelectorAll('.multiselect__tags')[4];
                if (combiningMultiselectTags) {
                    combiningMultiselectTags.style.cssText = removeStyles ? '' : 'padding: 8px 15px';
                }
            }
        },
        computed: {
            combiningOptions () {
                if (this.selectedDifficulty && this.selectedDifficulty.value > 1) {
                    let options = cloneDeep(this.difficulties);
                    return options.filter(option => {
                        return option.value <= this.selectedDifficulty.value;
                    }).map(option => {
                        return {
                            label: option.label,
                            value: option.value,
                            $isDisabled: false
                        };
                    });
                }
                return [];
            },
            combiningDisabled () {
                return this.gameState === 'started' || this.selectedDifficulty && this.selectedDifficulty.value === 1;
            }
        }
    }
</script>

<style scoped lang="scss">
    .multiplayer-game-menu__selectors {
        display: flex;
        width: 80%;
        margin: 20px;
        @media screen and (max-width: 1839px) {
            flex-wrap: wrap;
        }
    }
    .selector {
        margin: 0 10px;
        max-height: 44px;
        &:first-child {
            margin-left: 0;
        }
        @media screen and (max-width: 1839px) {
            max-width: 150px;
        }
        @media screen and (max-width: 1439px) {
            margin: 0 5px;
            max-width: 130px;
        }
    }
    .digits-combining-selector {
        width: 190% !important;
        margin: 0 20px 0 0;
        @media screen and (max-width: 1839px) {
            max-width: 310px;
        }
    }
    .players-selector {
        width: 85% !important;
        margin-left: 0;
        @media screen and (max-width: 1382px) {
            margin-top: 10px;
        }
    }
    .combining-checkbox-selector {
        max-height: 44px;
        display: flex;
        align-items: center;
        @media screen and (max-width: 1382px) {
            margin-top: 10px;
        }
    }
</style>